module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAAgBAMAAABA0y1rAAAAIVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABt0UjBAAAACnRSTlMA9RfBsIZMT75QLJCbTQAAAFNJREFUKM9jYMiQWoUNSCQwMLCuwgGWMjBUrcIFChisligwYAMqqwwYpBYxYAVMqwQYVi3ALgeUGJUblaOWHL40iC/t4knzE/DmFYZk7HlMOIEBABmeoctcvH0uAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hardware1.png
// module id = YQft
// module chunks = 2